import { render, staticRenderFns } from "./base_performance.vue?vue&type=template&id=fec4846a&scoped=true"
import script from "./base_performance.vue?vue&type=script&lang=ts"
export * from "./base_performance.vue?vue&type=script&lang=ts"
import style0 from "./base_performance.vue?vue&type=style&index=0&id=fec4846a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fec4846a",
  null
  
)

export default component.exports